export interface IFormState {
  isDirty: boolean;
}

export const formState: IFormState = {
  isDirty: false,
};
